import { navigateTo } from '@max/meituan-uni-navigate';
import { getPlatformType, isMiniProgramOrWebview, PlatformType } from '@nibfe/mkt-env-api';
export default function navigateToPage(link, dealId, channelId) {
    if (channelId) {
        // 交行app里有channelId，跳h5落地页
        let url = `https://i.meituan.com/awp/h5/lvyou/deal/ticket/detail/index.html?dealId=${dealId}&channelId=${channelId}`;
        window.location.href = url;
        return;
    }
    if (isMiniProgramOrWebview() && getPlatformType() === PlatformType.mtHotelMinaWebview) {
        navigateTo({
            url: `/pages/navigator/index?appId=wxde8ac0a21135c07d&path=${encodeURIComponent(link)}`,
            _web: {
                miniProgramNative: true
            }
        });
    }
    else {
        navigateTo({
            url: link,
            _web: {
                miniProgramNative: true
            }
        });
    }
}
